import axios from './axios';

const LangApi = {
    getAll: () => axios.get('/langs'),
    create: (data) => axios.post('/langs', data),
    update: (id, data) => axios.put(`/langs/${id}`, data),
    remove: (id) => axios.delete(`/langs/${id}`),
};

export default LangApi;
